import { Quill } from "react-quill";

export const IMAGE_FLOAT_LEFT_STYLE =
  "float:left;max-width:42%;height:auto;margin:0 1.5rem 1rem 0;border-radius:8px;";
export const IMAGE_FLOAT_RIGHT_STYLE =
  "float:right;max-width:42%;height:auto;margin:0 0 1rem 1.5rem;border-radius:8px;";

export const IMAGE_FLOAT_CLASSES = {
  left: "content-img-left",
  right: "content-img-right",
};

const BaseImage = Quill.import("formats/image");

class ContentImageFormat extends BaseImage {
  static formats(domNode) {
    const formats = super.formats(domNode) || {};

    Object.entries(IMAGE_FLOAT_CLASSES).forEach(([key, cls]) => {
      if (domNode.classList.contains(cls)) {
        formats.imageFloat = key;
      }
    });

    const inlineStyle = domNode.getAttribute("style") || "";
    if (!formats.imageFloat && inlineStyle.includes("float:left")) {
      formats.imageFloat = "left";
    }
    if (!formats.imageFloat && inlineStyle.includes("float:right")) {
      formats.imageFloat = "right";
    }

    if (domNode.hasAttribute("style")) {
      formats.style = domNode.getAttribute("style");
    }

    return formats;
  }

  format(name, value) {
    if (name === "imageFloat") {
      Object.values(IMAGE_FLOAT_CLASSES).forEach((cls) =>
        this.domNode.classList.remove(cls),
      );

      if (value === "left" || value === "right") {
        this.domNode.classList.add(IMAGE_FLOAT_CLASSES[value]);
        this.domNode.setAttribute(
          "style",
          value === "left" ? IMAGE_FLOAT_LEFT_STYLE : IMAGE_FLOAT_RIGHT_STYLE,
        );
      } else {
        this.domNode.removeAttribute("style");
      }
      return;
    }

    if (name === "style") {
      if (value) {
        this.domNode.setAttribute("style", value);
      } else {
        this.domNode.removeAttribute("style");
      }
      return;
    }

    super.format(name, value);
  }
}

ContentImageFormat.blotName = "image";
ContentImageFormat.tagName = "IMG";

Quill.register(ContentImageFormat, true);

const detectFloatFromNode = (node) => {
  if (node.classList.contains(IMAGE_FLOAT_CLASSES.left)) return "left";
  if (node.classList.contains(IMAGE_FLOAT_CLASSES.right)) return "right";

  const style = node.getAttribute("style") || "";
  if (style.includes("float:left")) return "left";
  if (style.includes("float:right")) return "right";
  return null;
};

export const contentClipboardMatchers = [
  [
    "IMG",
    (node, delta) => {
      const Delta = Quill.import("delta");
      const attributes = {};

      const imageFloat = detectFloatFromNode(node);
      if (imageFloat) attributes.imageFloat = imageFloat;

      if (node.getAttribute("style")) {
        attributes.style = node.getAttribute("style");
      }
      if (node.getAttribute("width")) {
        attributes.width = node.getAttribute("width");
      }
      if (node.getAttribute("height")) {
        attributes.height = node.getAttribute("height");
      }
      if (node.getAttribute("alt")) {
        attributes.alt = node.getAttribute("alt");
      }

      const src = node.getAttribute("src");
      if (!src) return delta;

      return new Delta().insert({ image: src }, attributes);
    },
  ],
];

export const applyFloatToSelectedImage = (quill, direction) => {
  const range = quill.getSelection(true);
  if (!range) return false;

  for (let offset = 0; offset <= 1; offset += 1) {
    const index = Math.max(0, range.index - offset);
    const [leaf] = quill.getLeaf(index);
    if (leaf?.statics?.blotName === "image") {
      quill.formatText(
        index,
        1,
        { imageFloat: direction },
        Quill.sources.USER,
      );
      return true;
    }
  }

  return false;
};

export const getQuillHtml = (quill) => quill?.root?.innerHTML ?? "";

/** Pastikan class float & URL gambar benar saat render di halaman publik. */
export const prepareRichContentHtml = (html) => {
  if (!html) return "";

  if (typeof document === "undefined") {
    return html;
  }

  const container = document.createElement("div");
  container.innerHTML = html;

  container.querySelectorAll("img").forEach((img) => {
    const style = (img.getAttribute("style") || "").toLowerCase();

    if (style.includes("float:left") || style.includes("float: left")) {
      img.classList.add(IMAGE_FLOAT_CLASSES.left);
    }
    if (style.includes("float:right") || style.includes("float: right")) {
      img.classList.add(IMAGE_FLOAT_CLASSES.right);
    }
  });

  return container.innerHTML;
};
